export const isEmpty = (value) => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
};

export const equalsIgnoreCase = (str1, str2) => {
  if (isEmpty(str1) || isEmpty(str2)) return str1 === str2;
  return str1.toLowerCase() === str2.toLowerCase();
};

export const removeEmptyValues = (obj) => {
  const cleaned = {};

  for (const [key, value] of Object.entries(obj)) {
    if (value !== null && value !== undefined && value !== "") {
      if (typeof value === "object" && !Array.isArray(value)) {
        const cleanedNested = removeEmptyValues(value);
        if (Object.keys(cleanedNested).length > 0) {
          cleaned[key] = cleanedNested;
        }
      } else {
        cleaned[key] = value;
      }
    }
  }

  return cleaned;
};

export const getMainIdentifier = (identifiers) => {
  if (!identifiers || identifiers.length === 0) return { type: "", value: "" };

  const sorted = [...identifiers].sort(
    (a, b) => a.priorityNumber - b.priorityNumber,
  );

  return {
    type: sorted[0].type,
    value: sorted[0].value,
  };
};

export const getPrimaryPostCode = (postCodes) => {
  if (!postCodes || postCodes.length === 0) return "";

  const primaryPostCode =
    postCodes.find((pc) => pc.postCodeTypeCode === "POSTCODE") || postCodes[0];
  return primaryPostCode.postCodeValue || "";
};

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
